/// <reference path="./jquery.d.ts" />

import { Application } from './application';

jQuery.extend({
    getQueryParameters: function (str?: string) {
        const queryString = (str || document.location.search).replace(/(^\?)/, '');
        const parameters: Record<string, string> = {};

        if (queryString.length === 0) {
            return parameters;
        }

        queryString.split('&').filter((item) => item.length > 0).forEach((item) => {
            const [key, value] = item.split('=');

            if (key) {
                parameters[key] = value;
            }
        });

        return parameters;
    }
});

let application: Application;

window.onload = () => {
    application = new Application();
    application.load();

    const interval = window.setInterval(() => {
        if (application.state) {
            window.clearInterval(interval);
            application.start();
        }
    }, 300);
};
